import { useQuery } from "@tanstack/react-query";
import { Link, useLocation } from "react-router";
import { env } from "@/shared/config/env";
import { useServices } from "@/shared/services/registry";
import { Icon } from "@/shared/ui";
import { readSceneEntry, preserveSceneState } from "@/shared/ui/sceneNavigation";
import { useCurrentFactData } from "@/features/memories/MemoriesPage";
import { heldCredentialCount } from "@/features/memories/facts";
import { credentialListKey } from "./data";

/** The former Memories summary, with the same scoped key, count and failed-read authority. */
export function CredentialEntry({ petId, userId }: { petId: string | null; userId: string | null }) {
  const services = useServices();
  const location = useLocation();
  const owner = userId ?? "-", pet = petId ?? "-";
  const enabled = Boolean(petId) && (env.dataMode !== "live" || Boolean(userId));
  const credentials = useQuery({ queryKey: credentialListKey(owner, pet), queryFn: ({ signal }) => services.life.credentials(pet, signal), enabled });
  const data = useCurrentFactData<NonNullable<typeof credentials.data>>(credentialListKey(owner, pet), enabled);
  const held = data ? heldCredentialCount(data) : null;
  const state = { ...preserveSceneState(location.state), sceneEntry: { version: 1, parent: "/me", origin: readSceneEntry(location.state, "/me")?.origin ?? "/me" } };
  return <li>
    <Link to="/life" state={state} className="ps-me-row" data-tone="leaf">
      <span className="ps-me-row__icon" aria-hidden="true"><Icon name="user" size={20} /></span>
      <span className="ps-me-row__text">
        <span className="ps-me-row__title">证件卡包</span>
        <span className="ps-me-row__meta" data-credential-description>星球发给 TA 的证件</span>
        {held !== null ? <span className="ps-me-row__meta" data-credential-fact>{held > 0 ? <>已持有 <b>{held}</b> 张</> : "还没有拿到证件"}</span> : null}
      </span>
      {held ? <Wallet count={held} /> : null}
      <Icon name="chevron" size={16} className="ps-me-row__go" />
    </Link>
  </li>;
}

/** 卡包的小插图：叠几张空白卡片，张数跟着已持有的数量（最多叠三张）；只是装饰，不画卡面信息。 */
function Wallet({ count }: { count: number }) {
  const cards = Math.min(count, 3);
  return (
    <span className="ps-mem-wallet" aria-hidden="true" data-cards={cards}>
      {Array.from({ length: cards }, (_, index) => (
        <i key={index} />
      ))}
    </span>
  );
}
